<template>
  <div class="bordered" :class="{ disabled: !keyword.enabled, deleting: keyword.deleting, resetting: keyword.resetting }">

    <div class="container-fill" @click="toggle">
      <div>
        {{ keyword.type }}:{{ keyword.value }}
        <span class="term" v-for="term in keyword.terms_and" :key="term"> AND {{term}}</span>
        <span class="term" v-for="term in keyword.terms_not" :key="term"> NOT {{term}}</span>
      </div>
      <div v-show="keyword.alert_limit">
        Alert limit:{{ keyword.alert_limit }}
      </div>
      <div v-show="keyword.document_limit">
        Document limit:{{ keyword.document_limit }}
      </div>
      <div id="keywordInfo">
        <div class="keyword-info">
          {{ keywordState }}
        </div>
        <div class="keyword-info">
          (alerts: {{ this.keyword.total_alerts}}, documents: {{ this.keyword.total_documents }})
          <input type="checkbox" v-model="keyword.selected">
        </div>
      </div>
    </div>

    <div class="details" v-show="isActive">
      <div id="keywordButtons">
        <button @click="updateKeyword" v-show="keyword.enabled">Update</button>
        <button @click="toggleKeyword" v-show="keyword.enabled">Disable</button>
        <button @click="toggleKeyword" v-show="!keyword.enabled">Enable</button>
        <button @click="resetKeyword">Reset</button>
        <button @click="deleteKeyword">Delete</button>
      </div>
      <div class="details-header">
        <div class="item">
          ID: {{ keyword.id }}
        </div>
        <h4>Additional search terms</h4>
        NOTE: You need to reset keyword in order to affect existing alerts when adding or removing terms!
      </div>
      <div class="container">
        <div class="item">
          <form v-on:submit.prevent="addTerm('AND')">
            <label for="filterText">AND:</label>
            <input v-model="newAndTerm" placeholder="Text" size="30">
            <button type="submit">Add new</button>
          </form>
          <li v-for="term in keyword.terms_and" :key="term">
            {{term}} <font-awesome-icon icon="trash" @click="removeTerm(term)"/>
          </li>
        </div>
        <div class="item">
          <form v-on:submit.prevent="addTerm('NOT')">
            <label for="filterTextNot">NOT:</label>
            <input v-model="newNotTerm" placeholder="Text" size="30">
            <button type="submit">Add new</button>
          </form>
          <li v-for="term in keyword.terms_not" :key="term">
            {{term}} <font-awesome-icon icon="trash" @click="removeTerm(term)"/>
          </li>
        </div>
      </div>
    </div>

    <pre class="debug" v-show="debugMode">{{ keyword }}</pre>
  
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#keywordInfo {
  display: inline-block;
  margin-right: 5px;
}
#keywordButtons {
  display: inline-block;
  float: right;
}
.keyword-info {
  display: inline-block;
  margin-right: 5px;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.term {
  font-size: small;
}
.item {
  margin: 10px;
}
.disabled {
  background-color: lightgrey;
}
.deleting {
  background-color: lightcoral;
}
.resetting {
  background-color: lightyellow;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    keyword: {
      type: Object,
      required: true
    }
  },
  computed: {
    keywordState () {
      if (this.keyword.resetting) return 'Resetting'
      if (this.keyword.deleting) return 'Deleting'
      if (this.keyword.updating) return 'Updating ' + this.keyword.progress + '%'
      if (!this.keyword.updated) return 'Waiting for update'
      return ''
    },
    ...mapState([
      'debugMode',
      'apiAuth'
    ])
  },
  data () {
    return {
      isActive: false,
      newAndTerm: '',
      newNotTerm: ''
    }
  },
  methods: {
    toggle: function (event) {
      if (event.target.tagName == 'BUTTON' || event.target.tagName == 'INPUT') return
      this.isActive = !this.isActive
    },
    toggleKeyword () {
      this.apiAuth.put('/keywords/' + this.keyword.id, {enabled: !this.keyword.enabled}).then(keyword => {
        this.keyword.enabled = keyword.enabled
      })
    },
    updateKeyword () {
      this.$store.dispatch('updateKeyword', this.keyword)
    },
    resetKeyword () {
      if (!confirm('Are you sure? This will delete all alerts permanently!')) return
      this.$store.dispatch('resetKeyword', this.keyword)
    },
    deleteKeyword () {
      if (!confirm('Are you sure? This will delete the keyword permanently!')) return
      this.$store.dispatch('deleteKeyword', this.keyword)
    },
    addTerm (type) {
      var params = { type: type }
      if (type === 'AND') params['value'] = this.newAndTerm
      if (type === 'NOT') params['value'] = this.newNotTerm
      this.apiAuth.post('/keywords/' + this.keyword.id + '/terms', params).then(keyword => {
        this.keyword.terms_and = keyword.terms_and
        this.keyword.terms_not = keyword.terms_not
        if (type === 'AND') this.newAndTerm = ''
        if (type === 'NOT') this.newNotTerm = ''
      })
    },
    removeTerm (term) {
      term = term.replace('#', '%23').replace('?', '%3F')
      this.apiAuth.delete('/keywords/' + this.keyword.id + '/terms/' + term).then(keyword => {
        this.keyword.terms_and = keyword.terms_and
        this.keyword.terms_not = keyword.terms_not
      })
    }
  }
}
</script>
